import React, { useState } from "react";
import TruckCompanyList from "../../Components/TruckCompanyItems/TruckCompanyList/TCList";

const TruckCompany = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [companiesPerPage, setCompaniesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="main-inner">
            <TruckCompanyList
              companiesPerPage={companiesPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              setCompaniesPerPage={setCompaniesPerPage}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default TruckCompany;
